import type { Paged } from "types/common.types"
import type {
  PowerlineReq,
  PowerlineRes,
  PowerlinesReq,
  PowerlinesRes,
} from "types/powerlines.types"
import type { PowerlineGeoReq, PowerlineGeoRes } from "types/geolocation.types"
import type {
  PowerlineTelemetryReq,
  PowerlineTelemetryRes,
  ValueSummaryRecord,
} from "types/telemetries.types"
import type { QualityRecord } from "types/quality.types"
import { api } from "./base"

export const powerlinesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    powerlines: builder.query<Paged<PowerlinesRes>, PowerlinesReq>({
      query: ({ params }) => ({
        url: "v1/powerlines",
        params,
      }),
      providesTags: (_result, _error, { params }) => [
        { type: "Powerline" as const, id: params.org_id },
      ],
    }),
    powerline: builder.query<PowerlineRes, PowerlineReq>({
      query: ({ id, params }) => ({
        url: `v1/powerlines/${id}`,
        params,
      }),
      providesTags: (_result, _error, { id }) => [{ type: "Powerline" as const, id }],
    }),
    powerlineGeo: builder.query<PowerlineGeoRes, PowerlineGeoReq>({
      query: ({ id, params }) => ({
        url: `/v1/powerlines/${id}/geo`,
        params,
      }),
    }),
    powerlineTelemetry: builder.query<PowerlineTelemetryRes, PowerlineTelemetryReq>({
      query: ({ id, params }) => ({
        url: `/v1/powerlines/${encodeURIComponent(id)}/telemetry`,
        params: {
          ...params,
          format: "json",
        },
      }),
    }),
    powerlineTelemetryQuality: builder.query<QualityRecord[], PowerlineTelemetryReq>({
      query: ({ id, params }) => ({
        url: `/v1/powerlines/${encodeURIComponent(id)}/telemetry`,
        params: {
          ...params,
          format: "json",
          only_quality_summary: true,
        },
      }),
    }),
    powerlineTelemetryValueSummary: builder.query<
      ValueSummaryRecord[],
      PowerlineTelemetryReq
    >({
      query: ({ id, params }) => ({
        url: `/v1/powerlines/${encodeURIComponent(id)}/telemetry`,
        params: {
          ...params,
          format: "json",
          only_value_summary: true,
        },
      }),
    }),
  }),
})
